/* Base URL delle API.
   In anteprima è la variabile d'ambiente; sul dominio personalizzato
   frontend e backend vivono sulla stessa origine, quindi usiamo
   quella (evita redirect apex→www e blocchi CORS del browser). */
const envUrl = process.env.REACT_APP_BACKEND_URL;

let API = envUrl;
try {
  if (
    window.location.hostname !== "localhost" &&
    envUrl &&
    new URL(envUrl).origin !== window.location.origin
  ) {
    API = window.location.origin;
  }
} catch {
  API = envUrl;
}

export default API;
